import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const TreatmentsPage = lazy(() => import('../pages/treatments/page'));
const MembershipPage = lazy(() => import('../pages/membership/page'));
const BookPage = lazy(() => import('../pages/book/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const ConfirmationPage = lazy(() => import('../pages/confirmation/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/treatments',
    element: <TreatmentsPage />,
  },
  {
    path: '/membership',
    element: <MembershipPage />,
  },
  {
    path: '/book',
    element: <BookPage />,
  },
  {
    path: '/booking',
    element: <BookPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/confirmation',
    element: <ConfirmationPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;